import { usePublishPlaceholderTemplateMutation } from '../../../../generated/graphql'
import useModal from '../../../../lib/hooks/useModal'
import useNotification from '../../../../lib/hooks/useNotification'
import { ConfirmPublishTemplateModal } from '../../templateModals'

type ConfirmPublishPlaceholderModalWrapperProps = {
  /** ID of Plan */
  id: string
  /** Determines visibility of modal */
  isOpen: boolean
}

const ConfirmPublishPlaceholderModalWrapper = ({
  id,
  isOpen
}: ConfirmPublishPlaceholderModalWrapperProps) => {
  const { hideModal } = useModal()
  const { showErrorNotif } = useNotification()

  const [publishPlaceholderTemplate, mutation] = usePublishPlaceholderTemplateMutation({
    variables: { input: id },
    onError: () => {
      hideModal()
      showErrorNotif('Placeholder could not be published.', publishPlaceholderTemplate)
    }
  })

  const onConfirm = () => {
    hideModal()
    publishPlaceholderTemplate()
  }

  if (!mutation.called) {
    return <ConfirmPublishTemplateModal isOpen={isOpen} onConfirm={onConfirm} label="Placeholder" />
  }

  return null
}

export default ConfirmPublishPlaceholderModalWrapper
